<template>
  <label 
    :for="`checkbox_${_uid}`"
    class="inline-flex space-x-2 items-center"
  >
    <input
      :id="`checkbox_${_uid}`"
      type="checkbox"
      class="form-checkbox h-4 w-4 text-green-600 disabled:text-gray-300 disabled:cursor-not-allowed"
      :checked="value"
      @change="$emit('input', $event.target.checked); $emit('change', $event)"
      v-bind="$attrs"
      v-on="listeners"
    />
    <span>
      <slot></slot>
    </span>
  </label>
</template>

<script>
export default {
  name: "BaseCheckbox",
  inheritAttrs: false,
  props: ['value'],
  computed: {
    listeners() {
      // eslint-disable-next-line
      const { change, input, ...listeners } = this.$listeners; 
      return listeners;
    }
  }
};
</script>
